import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { RimsService } from '@app/services/rims/rims.service';
import { Observable, tap } from 'rxjs';
import { LoadRimsPhaseInfos } from './rims.actions';
import { RimsPhaseInfo } from '@app/models/rims.model';

export interface RimsStateModel {
  rimsPhaseInfos: RimsPhaseInfo[];
}

@State<RimsStateModel>({
  name: 'rims',
  defaults: {
    rimsPhaseInfos: [],
  },
})
@Injectable()
export class RimsState {
  constructor(private rimsService: RimsService) {}

  @Selector()
  static getRimsPhaseInfos(state: RimsStateModel): RimsPhaseInfo[] {
    return state?.rimsPhaseInfos ?? [];
  }

  @Action(LoadRimsPhaseInfos)
  loadRimsPhaseInfos(ctx: StateContext<RimsStateModel>): Observable<RimsPhaseInfo[]> {
    return this.rimsService.getRimsPhaseInfos().pipe(
      tap((rimsPhaseInfos) => {
        ctx.patchState({ rimsPhaseInfos: [...rimsPhaseInfos] });
      }),
    );
  }
}
